import { RootState } from '../index'

export const selectCategories = (state: RootState) => state.products.data?.categories || {}
export const selectModifierGroups = (state: RootState) => state.products.data?.modifierGroups || {}
export const selectModifiers = (state: RootState) => state.products.data?.modifiers || {}
export const selectProducts = (state: RootState) => state.products.data?.products || {}
export const selectProductsLoading = (state: RootState): boolean => state.products.loading
